import { SubmissionError, reset } from "redux-form";
import cuid from "cuid";
import { closeModal } from "../modals/modalActions";
import { closeSideDrawer } from "../sideDrawer/sideDrawerActions";
import { toastr } from "react-redux-toastr";
import moment from "moment";

import firebase from "../../app/config/firebase";
import axios from "../../axios-firebase";

import {
  createSIMInventoryObject,
  createDeviceInventoryObject,
  createComputerInventoryObject,
  createDeviceAllocationObject,
  createReversalTransaction,
} from "../../app/common/util/helpers";

import {
  CREATE_INVENTORY_ITEM,
  UPDATE_INVENTORY_ITEM,
  DELETE_INVENTORY_ITEM,
  SELECT_INVENTORY_ITEM,
  FETCH_INVENTORY_ITEMS,
  FETCH_INVENTORY_UNALLOCATED_ITEMS,
} from "./inventoryConstants";

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "../async/asyncActions";

import { fetchSampleData } from "../../app/data/mockAPI";
import { getDayOfYear } from "date-fns";

export const fetchInventoryItems = (inventoryItems) => {
  return {
    type: FETCH_INVENTORY_ITEMS,
    payload: inventoryItems,
  };
};

// Creates the shared "BTC / NO SIM" placeholder SIM record in inventory.
// This is a one-time setup: the placeholder is never marked isAssigned or isAllocated,
// so any number of devices can be assigned/allocated under it.
export const createBtcNoSimPlaceholder = () => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const existing = await firestore
      .collection("inventory")
      .where("isBtcPlaceholder", "==", true)
      .get();

    if (!existing.empty) {
      toastr.warning("Warning", "BTC / NO SIM placeholder already exists in inventory");
      dispatch(asyncActionFinish());
      return;
    }

    const placeholder = {
      deviceType: "SIM",
      network: "BTC / NO SIM",
      cellNumber: "N/A",
      simNumber: "BTC-NO-SIM-PLACEHOLDER",
      isBtcPlaceholder: true,
      isAssigned: false,
      isAllocated: false,
      pinCode: "",
      pin2Code: "",
      pukNumber: "",
      dateCreated: new Date(),
      createdBy: currentUser,
      grnId: 0,
      grn: "BTC-NO-SIM",
      piNumber: "BTC-NO-SIM",
    };

    try {
      await firestore.collection("inventory").add(placeholder);
      dispatch(asyncActionFinish());
      toastr.success("Success", "BTC / NO SIM placeholder has been created");
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong creating the BTC / NO SIM placeholder");
    }
  };
};

// export const fetchUnallocatedSIMCards = unallocatedSIMCards => {
//   return {
//     type: FETCH_INVENTORY_UNALLOCATED_SIMCARDS,
//     payload: unallocatedSIMCards
//   };
// };/ export const getMerchantAllocatedInventory = (outletId, activeTab) => async (dispatch, getState) => {
export const batchWriteDeviceInventory = (poData, inventoryList) => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch(asyncActionStart());
    const currentUser = firebase.auth().currentUser.displayName;
    const dateNow = new Date();
    const today = dateNow.toISOString().slice(0, 10).replace(/-/g, "");

    let markInventoryList = [];

    const grnId = await generateGRNId();

    inventoryList.map((value) => {
      markInventoryList.push({
        grnId: grnId,
        grn: `${grnId}-${today}`,
        imei: value.imei,
        isAllocated: false,
        isAssignedSIM: false,
        macAddress: value.macAddress,
        manufacturer: poData.manufacturer,
        model: poData.model,
        serialNumber: value.serialNumber,
        deviceType: "Device",
        deviceNetworkType: "SIM",
        dateCreated: dateNow,
        wifiAddress: value.wifiAddress,
        createdBy: currentUser,
        piNumber: poData.piNumber,
      });
    });

    try {
      const batch = firebase.firestore().batch();
      console.log("inventory list to persistance", markInventoryList);
      markInventoryList.map((device) => {
        batch.set(firebase.firestore().collection("inventory").doc(), device);
      });

      console.log("Batch entry", batch);
      await batch.commit();

      console.log("batch write inventory", markInventoryList);

      dispatch(closeModal());
      toastr.success("Success", "Inventory list has been created");
    } catch (error) {
      console.log("Oops", "Something went wrong");

      toastr.error("Oops", "Something went wrong");
    }
  };
  // return querySnap;
};

export const batchWriteSimcardInventory = (poData, inventoryList) => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const currentUser = firebase.auth().currentUser.displayName;
    let network = "Mascom";
    const grnId = await generateGRNId();

    let markInventoryList = [];
    let dateNow = new Date();
    const today = dateNow.toISOString().slice(0, 10).replace(/-/g, "");

    inventoryList.map((value) => {
      markInventoryList.push({
        grnId: grnId,
        grn: `${grnId}-${today}`,
        createdBy: currentUser,
        dateCreated: dateNow,
        deviceType: "SIM",
        isAllocated: false,
        isAssigned: false,
        network: network,
        cellNumber: value.cellNumber,
        simNumber: value.simNumber,
        pinCode: value.pinCode,
        puk1: value.puk1,
        pinCode2: value.pinCode2,
        puk2: value.puk2,
        piNumber: poData.piNumber,
      });
    });

    try {
      const batch = firebase.firestore().batch();

      markInventoryList.map((simcard) => {
        batch.set(firebase.firestore().collection("inventory").doc(), simcard);
      });

      await batch.commit();
      console.log("batch write inventory", markInventoryList);

      dispatch(closeModal());
    } catch (error) {
      console.log("Oops", "Something went wrong");
      console.log(error, error);
      toastr.error("Oops", "Something went wrong");
    }
  };
  // return querySnap;
};
export const fetchUnallocatedItems = () => async (dispatch, getState) => {
  dispatch(asyncActionStart());
  const firestore = firebase.firestore();
  const today = new Date(Date.now());
  let inventoryRef = firestore.collection("inventory");
  let query;

  try {
    dispatch(asyncActionStart());

    query = inventoryRef.where("isAllocated", "==", false);

    let querySnap = await query.get();

    if (querySnap.docs.length === 0) {
      dispatch(asyncActionFinish());
      // return querySnap;
    }

    let inventoryItems = [];

    for (let i = 0; i < querySnap.docs.length; i++) {
      let item = { ...querySnap.docs[i].data(), id: querySnap.docs[i].id };
      inventoryItems.push(item);
    }

    dispatch({ type: FETCH_INVENTORY_ITEMS, payload: { inventoryItems } });
    dispatch(asyncActionFinish());
    // return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const selectInventoryItem = (inventoryItem) => {
  return {
    type: SELECT_INVENTORY_ITEM,
    payload: {
      inventoryItem,
    },
  };
};

export const createDeviceInventoryItem = (inventoryItem) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const user = firebase.auth().currentUser.displayName;

    let newInventoryItem = createDeviceInventoryObject(inventoryItem, user);

    try {
      let createdInventoryItem = await firestore.add(
        `inventory`,
        newInventoryItem
      );
      dispatch(closeModal());
      toastr.success("Success", "InventoryItem has been created");
    } catch (error) {
      console.log("Oops", "Something went wrong");

      toastr.error("Oops", "Something went wrong");
    }
  };
};
export const generateGRNId = async () => {
  const firestore = firebase.firestore();

  const inventoryId = await firestore
    .collection("inventory")
    .limit(1)
    .get()
    .then(async (doc) => {
      return await firestore
        .collection("inventory")
        .orderBy("grnId", "desc")
        .get()
        .then((doc) => {
          if (doc.empty) {
            return 0;
          } else {
            return doc.docs[0].data().grnId;
          }
        });
    });

  return inventoryId + 1;
};

export const createComputerInventoryItem = (inventoryItem) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const user = firebase.auth().currentUser.displayName;

    let newInventoryItem = createComputerInventoryObject(inventoryItem, user);

    try {
      let createdInventoryItem = await firestore.add(
        `inventory`,
        newInventoryItem
      );
      dispatch(closeModal());
      toastr.success("Success", "InventoryItem has been created");
    } catch (error) {
      console.log("Oops", "Something went wrong");

      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const createSIMInventoryItem = (inventoryItem) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const user = firebase.auth().currentUser.displayName;

    let newInventoryItem = createSIMInventoryObject(inventoryItem, user);

    try {
      let createdInventoryItem = await firestore.add(
        `inventory`,
        newInventoryItem
      );
      dispatch(closeModal());
      toastr.success("Success", "InventoryItem has been created");
    } catch (error) {
      console.log("Oops", "Something went wrong");

      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const allocateInventoryItem = (allocation /* , deviceAgreement */) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    console.log("allocation", allocation);

    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    let device = await firestore
      .collection("inventory")
      .doc(allocation.device.value.id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let device = doc.data();
          device.id = doc.id;
          return device;
        }
      });

    let sim = await firestore
      .collection("inventory")
      .doc(allocation.device.value.assignedSIMId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let sim = doc.data();
          sim.id = doc.id;
          return sim;
        }
      });

    const outletId = allocation.outletId;
    const account = allocation.account;

    console.log("allocation", allocation);

    let deviceAllocationObject = createDeviceAllocationObject(
      account,
      outletId,
      device,
      sim,
      currentUser
    );

    let query;

    try {
      /* uploadDeviceAgreement(
        deviceAgreement,
        account,
        outletId,
        dispatch,
        firebase
      ); */

      let dateAllocated = new Date();
      // Create a ref with auto-generated ID
      let deviceAllocationRef = firestore.collection("outlet_inventory").doc();

      let batch = firestore.batch();

      const contractRef = firestore
        .collection("deviceAllocationContracts")
        .doc();

      const contractTransactionRef = firestore.collection("transactions").doc();

      const currDate = new Date();

      console.log(
        "allocation.devicePlan.value.plan",
        allocation.devicePlan.value.plan
      );
      const contract = allocation.devicePlan.value.plan;
      const contractStatus =
        contract === "Free" || contract === "Cash" || contract === "Layby" ? "Completed" : "Active";
      const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

      const scheduleStartDate =
        contract === "Free" || contract === "Cash" || contract === "Layby"
          ? new Date()
          : moment(currDate).add(1, "month").startOf("month").toDate(); // set to 12:00 am today
      const scheduleEndDate =
        contract === "Free" || contract === "Cash" || contract === "Layby"
          ? new Date()
          : moment(currDate).add(25, "month").endOf("month").toDate(); // set to 23:59 pm today

      batch.set(contractRef, {
        account: account,
        outletId: outletId,
        deviceSerialNumber: allocation.device.value.serialNumber,
        deviceId: allocation.device.value.id,
        cellNumber: allocation.device.value.cellNumber,
        deviceType: allocation.device.value.deviceType,
        createdBy: "Prepaid Administrator",
        dateCreated: new Date(),
        deposit: allocation.devicePlan.value.deposit,
        installmentAmount: allocation.devicePlan.value.installmentAmount,
        installmentPeriodInMonths:
          allocation.devicePlan.value.installmentPeriodInMonths,
        plan: contract,
        contractAmount:
          allocation.devicePlan.value.deposit +
          allocation.devicePlan.value.installmentPeriodInMonths *
          allocation.devicePlan.value.installmentAmount,
        amountPaid: 0,
        amountOutstanding:
          allocation.devicePlan.value.deposit +
          allocation.devicePlan.value.installmentPeriodInMonths *
          allocation.devicePlan.value.installmentAmount,
        contractRemaining:
          allocation.devicePlan.value.installmentPeriodInMonths,
        contractStatus: contractStatus,
        contractStartDate: scheduleStartDate,
        contractEndDate: scheduleEndDate,
      });

      if (contract !== "Free" && contract !== "Cash" && contract !== "Layby") {
        batch.set(contractTransactionRef, {
          account: account,
          outletId: outletId,
          isTransactionCharged: false,
          group: "Individual",
          merchantName: allocation.merchantName,
          outletName: allocation.outletName,
          amountPaid: 0,
          amountOutstanding:
            allocation.devicePlan.value.deposit +
            allocation.devicePlan.value.installmentPeriodInMonths *
            allocation.devicePlan.value.installmentAmount,
          contractRemaining:
            allocation.devicePlan.value.installmentPeriodInMonths,
          contract: contract,
          deviceContract: contractRef.id,
          transactionAmount: allocation.devicePlan.value.deposit,
          deviceSerialNumber: allocation.device.value.serialNumber,
          deviceId: allocation.device.value.id,
          cellNumber: allocation.device.value.cellNumber,
          deviceType: allocation.device.value.deviceType,
          transactionStatus: "Successful",
          transactionDateTime: serverTimestamp,
          createdBy: "Prepaid Administrator",
          dateCreated: serverTimestamp,
          deviceContractTransactionType: "Deposit",
          transactionType: "DeviceContract",
          transactionCategory: "Debit",
        });
      }

      if (contract === "Free" || contract === "Cash" || contract == "Layby") {
        batch.set(contractTransactionRef, {
          account: account,
          outletId: outletId,
          isTransactionCharged: false,
          group: "Individual",
          merchantName: allocation.merchantName,
          outletName: allocation.outletName,
          amountPaid: 0,
          amountOutstanding: 0,
          contractRemaining: 0,
          contract: contract,
          deviceContract: contractRef.id,
          transactionAmount: allocation.devicePlan.value.deposit,
          deviceSerialNumber: allocation.device.value.serialNumber,
          deviceId: allocation.device.value.id,
          cellNumber: allocation.device.value.cellNumber,
          deviceType: allocation.device.value.deviceType,
          transactionStatus: "Successful",
          transactionDateTime: serverTimestamp,
          createdBy: "Prepaid Administrator",
          dateCreated: serverTimestamp,
          deviceContractTransactionType: "Deposit",
          transactionType: "DeviceContract",
          transactionCategory: "Debit",
        });
      }

      const deviceRef = firestore.collection("inventory").doc(device.id);
      batch.update(deviceRef, {
        isAllocated: true,
        cellNumber: sim.cellNumber,
        allocatedTo: outletId,
        dateAllocated: dateAllocated,
      });

      // Never mark the BTC / NO SIM placeholder as allocated — it is shared across all BTC devices
      if (!sim.isBtcPlaceholder) {
        const simRef = firestore.collection("inventory").doc(sim.id);
        batch.update(simRef, {
          isAllocated: true,
          allocatedTo: outletId,
          dateAllocated: dateAllocated,
        });
      }

      deviceAllocationObject.outletAssignmentId = deviceAllocationRef.id;

      await batch.set(deviceAllocationRef, deviceAllocationObject);

      await batch.commit();

      dispatch(fetchOutletInventory(outletId));
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.success("Success", "InventoryItem has been created");
      // return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const amendDeviceContract = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const {
      deviceContract,
      outletName,
      group,
      merchantName,
      devicePlan,
      change_reason,
    } = values;

    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    let device = await firestore
      .collection("inventory")
      .doc(deviceContract.deviceId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let device = doc.data();
          device.id = doc.id;
          return device;
        }
      });

    let activeContractRef = await firestore
      .collection("deviceAllocationContracts")
      .doc(deviceContract.id);

    let query;
    const transactionsRef = firestore.collection("transactions");
    query = transactionsRef
      .where("deviceContractTransactionType", "==", "Deposit")
      .where("deviceId", "==", deviceContract.deviceId)
      .where("contract", "==", deviceContract.plan);

    let querySnap = await query.get();

    const contractHasDepostit = deviceContract.plan !== "Free" ? true : false;

    if (querySnap.docs.length === 0 && contractHasDepostit) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract deposit could not be found");
      return querySnap;
    }

    let deposit = contractHasDepostit
      ? {
        ...querySnap.docs[0].data(),
        id: querySnap.docs[0].id,
        reversalReason: change_reason,
      }
      : null;

    let reverseTransactionObject = contractHasDepostit
      ? createReversalTransaction(deposit, "Credit", currentUser)
      : null;

    let contractQuery;
    const deviceAllocationContractsRef = firestore.collection(
      "deviceAllocationContracts"
    );
    contractQuery = deviceAllocationContractsRef
      .where("deviceId", "==", deviceContract.deviceId)
      .where("plan", "==", deviceContract.plan);

    let contractQuerySnap = await contractQuery.get();

    if (contractQuerySnap.docs.length === 0) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract could not be found");
      return contractQuerySnap;
    }

    let contract = {
      ...contractQuerySnap.docs[0].data(),
      id: contractQuerySnap.docs[0].id,
    };

    try {
      let batch = firestore.batch();

      const contractRef = firestore
        .collection("deviceAllocationContracts")
        .doc();

      const contractTransactionRef = firestore.collection("transactions").doc();
      const reversalTransactionRef = firestore.collection("transactions").doc();

      const currDate = new Date();

      const contract = devicePlan.value.plan;

      const contractStatus =
        contract === "Free" || contract === "Cash" || contract === "Layby" ? "Completed" : "Active";
      const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

      const contractMonths = devicePlan.value.installmentPeriodInMonths + 1;

      const scheduleStartDate =
        contract === "Free" || contract === "Cash" || contract === "Layby"
          ? new Date()
          : moment(currDate).add(1, "month").startOf("month").toDate(); // set to 12:00 am today
      const scheduleEndDate =
        contract === "Free" || contract === "Cash" || contract === "Layby"
          ? new Date()
          : moment(currDate)
            .add(contractMonths, "month")
            .endOf("month")
            .toDate(); // set to 23:59 pm today

      batch.set(contractRef, {
        account: deviceContract.account,
        outletId: deviceContract.outletId,
        deviceSerialNumber: device.serialNumber,
        deviceId: device.id,
        cellNumber: deviceContract.cellNumber,
        deviceType: deviceContract.deviceType,
        createdBy: "Prepaid Administrator",
        dateCreated: new Date(),
        deposit: devicePlan.value.deposit,
        installmentAmount: devicePlan.value.installmentAmount,
        installmentPeriodInMonths: devicePlan.value.installmentPeriodInMonths,
        plan: contract,
        contractAmount:
          devicePlan.value.deposit +
          devicePlan.value.installmentPeriodInMonths *
          devicePlan.value.installmentAmount,
        amountPaid: 0,
        amountOutstanding:
          devicePlan.value.deposit +
          devicePlan.value.installmentPeriodInMonths *
          devicePlan.value.installmentAmount,
        contractRemaining: devicePlan.value.installmentPeriodInMonths,
        contractStatus: contractStatus,
        contractStartDate: scheduleStartDate,
        contractEndDate: scheduleEndDate,
      });

      batch.update(activeContractRef, {
        contractStatus: "Cancelled",
        cancelledBy: firebase.firestore.FieldValue.delete(),
        reasonForCancellation: firebase.firestore.FieldValue.delete(),
        updatedBy: currentUser,
        dateUpdated: new Date(),
      });

      if (contractHasDepostit) {
        batch.set(reversalTransactionRef, reverseTransactionObject);
      }
      if (contract !== "Free" && contract !== "Cash" && contract !== "Layby") {
        batch.set(contractTransactionRef, {
          account: deviceContract.account,
          outletId: deviceContract.outletId,
          isTransactionCharged: false,
          group: group,
          merchantName: merchantName,
          outletName: outletName,
          amountPaid: 0,
          amountOutstanding:
            devicePlan.value.deposit +
            devicePlan.value.installmentPeriodInMonths *
            devicePlan.value.installmentAmount,
          contractRemaining: devicePlan.value.installmentPeriodInMonths,
          contract: contract,
          deviceContract: contractRef.id,
          transactionAmount: devicePlan.value.deposit,
          deviceSerialNumber: device.serialNumber,
          deviceId: device.id,
          cellNumber: device.cellNumber,
          deviceType: device.deviceType,
          transactionStatus: "Successful",
          transactionDateTime: serverTimestamp,
          createdBy: "Prepaid Administrator",
          dateCreated: serverTimestamp,
          deviceContractTransactionType: "Deposit",
          transactionType: "DeviceContract",
          transactionCategory: "Debit",
        });
      }

      if (contract === "Free" || contract === "Cash" || contract === "Layby") {
        batch.set(contractTransactionRef, {
          account: deviceContract.account,
          outletId: deviceContract.outletId,
          isTransactionCharged: false,
          group: group,
          merchantName: merchantName,
          outletName: outletName,
          amountPaid: 0,
          amountOutstanding: 0,
          contractRemaining: 0,
          contract: contract,
          deviceContract: contractRef.id,
          transactionAmount: devicePlan.value.deposit,
          deviceSerialNumber: device.serialNumber,
          deviceId: device.id,
          cellNumber: device.cellNumber,
          deviceType: device.deviceType,
          transactionStatus: "Successful",
          transactionDateTime: serverTimestamp,
          createdBy: "Prepaid Administrator",
          dateCreated: serverTimestamp,
          deviceContractTransactionType: "Deposit",
          transactionType: "DeviceContract",
          transactionCategory: "Debit",
        });
      }

      await batch.commit();

      dispatch(fetchOutletInventory(deviceContract.outletId));
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.success("Success", "Contract has been changed");
      // return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const makeAdhocPayment = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const { deviceContract, outletName, group, merchantName, devicePlan } =
      values;

    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    let device = await firestore
      .collection("inventory")
      .doc(deviceContract.deviceId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let device = doc.data();
          device.id = doc.id;
          return device;
        }
      });

    let activeContractRef = await firestore
      .collection("deviceAllocationContracts")
      .doc(deviceContract.id);

    let query;
    const transactionsRef = firestore.collection("transactions");
    query = transactionsRef
      .where("deviceContractTransactionType", "==", "Deposit")
      .where("deviceId", "==", deviceContract.deviceId)
      .where("contract", "==", deviceContract.plan);

    let querySnap = await query.get();

    const contractHasDepostit = deviceContract.plan !== "Free" ? true : false;

    console.log("devicePlan.plan", deviceContract.plan);
    console.log("contractHasDepostit", contractHasDepostit);

    if (querySnap.docs.length === 0 && contractHasDepostit) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract deposit could not be found");
      return querySnap;
    }

    console.log("deviceContract", deviceContract);
    console.log("deviceContract.deviceContract", deviceContract.id);
    console.log("devicePlan", devicePlan);

    let contractQuery;
    const deviceAllocationContractsRef = firestore.collection(
      "deviceAllocationContracts"
    );
    contractQuery = deviceAllocationContractsRef
      .where("deviceId", "==", deviceContract.deviceId)
      .where("plan", "==", deviceContract.plan);

    let contractQuerySnap = await contractQuery.get();

    if (contractQuerySnap.docs.length === 0) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract could not be found");
      return contractQuerySnap;
    }

    try {
      let batch = firestore.batch();

      const contractTransactionRef = firestore.collection("transactions").doc();
      const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

      batch.set(contractTransactionRef, {
        account: deviceContract.account,
        outletId: deviceContract.outletId,
        isTransactionCharged: false,
        group: group,
        merchantName: merchantName,
        outletName: outletName,
        amountPaid: deviceContract.amountPaid,
        amountOutstanding: deviceContract.amountOutstanding,
        contract: deviceContract.plan,
        contractRemainingBeforeTransaction: deviceContract.contractRemaining,

        contractRemaining: Math.ceil(
          (deviceContract.amountOutstanding - +values.paymentAmount) /
          deviceContract.installmentAmount
        ),
        deviceContract: deviceContract.id,
        transactionAmount: +values.paymentAmount,
        deviceSerialNumber: device.serialNumber,
        deviceId: device.id,
        cellNumber: device.cellNumber,
        deviceType: device.deviceType,
        transactionStatus: "Successful",
        transactionDateTime: serverTimestamp,
        createdBy: "Prepaid Administrator",
        dateCreated: serverTimestamp,
        deviceContractTransactionType: "AdhocPayment",
        transactionType: "DeviceContract",
        transactionCategory: "Debit",
      });

      await batch.commit();

      dispatch(fetchOutletInventory(deviceContract.outletId));

      // console.log("adhocPayment", {
      //   account: deviceContract.account,
      //   outletId: deviceContract.outletId,
      //   isTransactionCharged: true,
      //   group: group,
      //   merchantName: merchantName,
      //   outletName: outletName,
      //   amountPaid: deviceContract.amountPaid,
      //   contract: deviceContract.plan,
      //   contractRemainingBeforeTransaction: deviceContract.contractRemaining,
      //   contractRemaining: Math.ceil(
      //     (deviceContract.amountOutstanding - +values.paymentAmount) /
      //       deviceContract.installmentAmount
      //   ),
      //   deviceContract: deviceContract.id,
      //   transactionAmount: +values.paymentAmount,
      //   deviceSerialNumber: device.serialNumber,
      //   deviceId: device.id,
      //   cellNumber: device.cellNumber,
      //   deviceType: device.deviceType,
      //   transactionStatus: "Successful",
      //   transactionDateTime: new Date(),
      //   createdBy: "Prepaid Administrator",
      //   dateCreated: new Date(),
      //   deviceContractTransactionType: "AdhocPayment",
      //   transactionType: "DeviceContract",
      //   transactionCategory: "Debit",
      // });

      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.success("Success", "Contract has been changed");
      // return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const makeManualDevicePayment = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const { deviceContract, outletName, group, merchantName } = values;

    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    // let device = await firestore
    //   .collection("inventory")
    //   .doc(deviceContract.deviceId)
    //   .get()
    //   .then((doc) => {
    //     if (doc.exists) {
    //       let device = doc.data();
    //       device.id = doc.id;
    //       return device;
    //     }
    //   });

    // let activeContractRef = await firestore
    //   .collection("deviceAllocationContracts")
    //   .doc(deviceContract.id);

    let query;
    const transactionsRef = firestore.collection("transactions");
    query = transactionsRef
      .where("deviceContractTransactionType", "==", "Deposit")
      .where("deviceId", "==", deviceContract.deviceId)
      .where("contract", "==", deviceContract.plan);

    let querySnap = await query.get();

    const contractHasDepostit = deviceContract.plan !== "Free" ? true : false;

    // console.log("devicePlan.plan", deviceContract.plan);
    // console.log("contractHasDepostit", contractHasDepostit);

    if (querySnap.docs.length === 0 && contractHasDepostit) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract deposit could not be found");
      return querySnap;
    }

    // console.log("deviceContract", deviceContract);
    // console.log("deviceContract.deviceContract", deviceContract.id);
    // console.log("outletName", outletName);
    // console.log("group", group);
    // console.log("merchantName", merchantName);

    let contractQuery;
    const deviceAllocationContractsRef = firestore.collection(
      "deviceAllocationContracts"
    );
    contractQuery = deviceAllocationContractsRef
      .where("deviceId", "==", deviceContract.deviceId)
      .where("plan", "==", deviceContract.plan);

    let contractQuerySnap = await contractQuery.get();

    if (contractQuerySnap.docs.length === 0) {
      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.error("Failure", "Contract could not be found");
      return contractQuerySnap;
    }

    try {
      // console.log({
      //   account: deviceContract.account,
      //   outletId: deviceContract.outletId,
      //   isTransactionCharged: false,
      //   group: group,
      //   merchantName: merchantName,
      //   outletName: outletName,
      //   amountPaid: deviceContract.amountPaid,
      //   amountOutstanding: deviceContract.amountOutstanding,
      //   contractRemaining: deviceContract.contractRemaining,
      //   contract: deviceContract.plan,
      //   deviceContract: deviceContract.id,
      //   transactionAmount: deviceContract.installmentAmount,
      //   deviceSerialNumber: deviceContract.deviceSerialNumber,
      //   deviceId: deviceContract.deviceId,
      //   cellNumber: deviceContract.cellNumber,
      //   deviceType: deviceContract.deviceType,
      //   transactionStatus: "Successful",
      //   transactionDateTime: new Date(),
      //   createdBy: "Prepaid Administrator",
      //   dateCreated: new Date(),
      //   deviceContractTransactionType: "Installment",
      //   transactionType: "DeviceContract",
      //   transactionCategory: "Debit",
      // });

      let batch = firestore.batch();

      const instalmentTransactionRef = firestore
        .collection("transactions")
        .doc();
      const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

      batch.set(instalmentTransactionRef, {
        account: deviceContract.account,
        outletId: deviceContract.outletId,
        isTransactionCharged: false,
        group: group,
        merchantName: merchantName,
        outletName: outletName,
        amountPaid: deviceContract.amountPaid,
        amountOutstanding: deviceContract.amountOutstanding,
        contractRemaining: deviceContract.contractRemaining,
        contract: deviceContract.plan,
        deviceContract: deviceContract.id,
        transactionAmount: deviceContract.installmentAmount,
        deviceSerialNumber: deviceContract.deviceSerialNumber,
        deviceId: deviceContract.deviceId,
        cellNumber: deviceContract.cellNumber,
        deviceType: deviceContract.deviceType,
        transactionStatus: "Successful",
        transactionDateTime: serverTimestamp,
        createdBy: currentUser,
        dateCreated: serverTimestamp,
        deviceContractTransactionType: "Installment",
        transactionType: "DeviceContract",
        transactionCategory: "Debit",
      });

      await batch.commit();

      dispatch(fetchOutletInventory(deviceContract.outletId));

      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.success("Success", "Installment has been paid");
      // return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

const uploadDeviceAgreement = (
  deviceAgreement,
  account,
  outletId,
  dispatch,
  firebase
) => {
  const agreementName = `${outletId}DeviceContract`;
  const path = `${account}/${outletId}/devicecontracts`; //MerchantID
  const options = {
    name: agreementName,
  };
  try {
    dispatch(asyncActionStart());
    // upload the file to fb storage
    firebase.uploadFile(path, deviceAgreement, null, options);
    dispatch(asyncActionFinish());
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
    throw new Error("Problem uploading merchant document");
  }
};

export const updateInventoryItem = (inventoryItem) => {
  return {
    type: UPDATE_INVENTORY_ITEM,
    payload: {
      inventoryItem,
    },
  };
};

export const deleteInventoryItem = (inventoryItemId) => {
  return {
    type: DELETE_INVENTORY_ITEM,
    payload: {
      inventoryItemId,
    },
  };
};

export const fetchOutletInventory =
  (outletId) => async (dispatch, getState) => {
    console.log("outletId", outletId);
    const firestore = firebase.firestore();
    const outletInventoryRef = firestore.collection("outlet_inventory");
    try {
      dispatch(asyncActionStart());

      let query;

      query = outletInventoryRef.where("outletId", "==", outletId);

      let querySnap = await query.get();

      if (querySnap.docs.length === 0) {
        dispatch(asyncActionFinish());
        return querySnap;
      }

      let inventoryItems = [];

      for (let i = 0; i < querySnap.docs.length; i++) {
        let inventory = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        inventoryItems.push(inventory);
      }

      dispatch({ type: FETCH_INVENTORY_ITEMS, payload: { inventoryItems } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const resetOutletInventory = () => async (dispatch, getState) => {
  try {
    dispatch(asyncActionStart());

    let inventoryItems = [];
    dispatch({ type: FETCH_INVENTORY_ITEMS, payload: { inventoryItems } });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const fetchOutletComputers =
  (outletId) => async (dispatch, getState) => {
    const firestore = firebase.firestore();
    const outletComputersRef = firestore.collection("outlet_computers");
    try {
      dispatch(asyncActionStart());

      let query;

      query = outletComputersRef.where("outletId", "==", outletId);

      let querySnap = await query.get();

      if (querySnap.docs.length === 0) {
        dispatch(asyncActionFinish());
        return querySnap;
      }

      let computers = [];

      for (let i = 0; i < querySnap.docs.length; i++) {
        let inventory = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        computers.push(inventory);
      }

      dispatch({ type: FETCH_INVENTORY_ITEMS, payload: { computers } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const resetOutletComputers = () => async (dispatch, getState) => {
  try {
    dispatch(asyncActionStart());

    let computers = [];
    dispatch({ type: FETCH_INVENTORY_ITEMS, payload: { computers } });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const unAssignSIMFromDevice = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    const simInventoryId = values.device.simId;
    const deviceInventoryId = values.device.deviceId;

    // Check whether the SIM being unlinked is the shared BTC / NO SIM placeholder
    const simDoc = await firestore.collection("inventory").doc(simInventoryId).get();
    const isBtcPlaceholder = simDoc.exists && simDoc.data().isBtcPlaceholder === true;

    try {
      let deviceInventoryRef = firestore
        .collection("inventory")
        .doc(deviceInventoryId);

      let batch = firestore.batch();

      batch.update(deviceInventoryRef, {
        assignedSIMId: firebase.firestore.FieldValue.delete(),
        cellAssignedBy: firebase.firestore.FieldValue.delete(),
        dateCellAssigned: firebase.firestore.FieldValue.delete(),
        cellNumber: firebase.firestore.FieldValue.delete(),
        isAssignedSIM: false,
        isBtcPlaceholder: firebase.firestore.FieldValue.delete(),
        updatedBy: currentUser,
        dateUpdated: now,
      });

      // Never modify the BTC / NO SIM placeholder — it must remain available for all devices
      if (!isBtcPlaceholder) {
        let simInventoryRef = firestore
          .collection("inventory")
          .doc(simInventoryId);
        batch.update(simInventoryRef, {
          assignedMacAddress: firebase.firestore.FieldValue.delete(),
          assignedTo: firebase.firestore.FieldValue.delete(),
          cellAssignedBy: firebase.firestore.FieldValue.delete(),
          dateCellAssigned: firebase.firestore.FieldValue.delete(),
          isAssigned: false,
          updatedBy: currentUser,
          dateUpdated: now,
        });
      }

      await batch.commit();
      dispatch(closeModal());
      dispatch(closeSideDrawer());
      toastr.success("Success", "SIM Card has been unlinked from device");
    } catch (error) {
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const assignSIMToDevice = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const simInventoryId = values.sim.value.id;
    const simCellNumber = values.sim.value.cellNumber;
    const isBtcPlaceholder = values.sim.value.isBtcPlaceholder === true;
    const deviceInventoryId = values.device.deviceId;
    const deviceMACAddress = values.device.macAddress;

    const now = new Date();

    try {
      let deviceInventoryRef = firestore
        .collection("inventory")
        .doc(deviceInventoryId);

      let batch = firestore.batch();

      batch.update(deviceInventoryRef, {
        assignedSIMId: simInventoryId,
        isAssignedSIM: true,
        isBtcPlaceholder: isBtcPlaceholder,
        cellNumber: simCellNumber,
        cellAssignedBy: currentUser,
        dateCellAssigned: now,
      });

      // The BTC / NO SIM placeholder is shared across devices — never mark it as assigned
      if (!isBtcPlaceholder) {
        let simInventoryRef = firestore
          .collection("inventory")
          .doc(simInventoryId);
        batch.update(simInventoryRef, {
          assignedTo: deviceInventoryId,
          assignedMacAddress: deviceMACAddress,
          isAssigned: true,
          cellAssignedBy: currentUser,
          dateCellAssigned: now,
        });
      }

      await batch.commit();
      dispatch(closeModal());
      dispatch(closeSideDrawer());
      toastr.success("Success", "SIM Card has been assigned to device");
    } catch (error) {
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const unassignDeviceFromOutlet = (
  deviceId,
  simId,
  outletAssignmentId
) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    // Determine whether this device used the shared BTC / NO SIM placeholder
    const simDoc = await firestore.collection("inventory").doc(simId).get();
    const isBtcPlaceholder = simDoc.exists && simDoc.data().isBtcPlaceholder === true;

    try {
      let simRef = firestore.collection("inventory").doc(simId);

      let outletPairingRef = firestore
        .collection("outlet_inventory")
        .doc(outletAssignmentId);

      let deviceRef = firestore.collection("inventory").doc(deviceId);

      let inventoryPairingId = await firestore
        .collection("inventory_pairing")
        .where("registrationId", "==", outletAssignmentId)
        .get()
        .then(async (querySnapshot) => {
          if (querySnapshot.size) {
            const docs = querySnapshot.docs;
            const id = docs[0].id;

            return id;
          } else {
            return null;
          }
        });

      let batch = firestore.batch();

      // Add it in the batch
      await batch.update(deviceRef, {
        allocatedTo: firebase.firestore.FieldValue.delete(),
        dateAllocated: firebase.firestore.FieldValue.delete(),
        isAllocated: false,
        updatedBy: currentUser,
        dateUpdated: now,
      });

      // Never modify the BTC / NO SIM placeholder during unallocation — it stays permanently available
      if (!isBtcPlaceholder) {
        await batch.update(simRef, {
          allocatedTo: firebase.firestore.FieldValue.delete(),
          dateAllocated: firebase.firestore.FieldValue.delete(),
          isAllocated: false,
          updatedBy: currentUser,
          dateUpdated: now,
        });
      }

      await batch.delete(outletPairingRef);

      // Only delete inventory pairing if it exists
      if (inventoryPairingId) {
        let inventoryPairingRef = await firestore
          .collection("inventory_pairing")
          .doc(inventoryPairingId);
        await batch.delete(inventoryPairingRef);
      }

      await batch.commit();
      dispatch(closeModal());
      dispatch(closeSideDrawer());
      toastr.success("Success", "Device has been unlinked from outlet");
    } catch (error) {
      toastr.error("Oops", "Something went wrong");
    }
  };
};
